<template>
  <div>
    <!-- modal -->
    <matter-smuggling-form ref="matterSmugglingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-smuggling-form>
    <matter-consulting-form ref="matterConsultingFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-consulting-form>
    <matter-customs-registration-form ref="matterCustomsRegistrationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-customs-registration-form>
    <matter-stop-customs-form ref="matterStopCustomsFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-stop-customs-form>
    <matter-evidence-detection-form ref="matterEvidenceDetectionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-evidence-detection-form>
    <matter-mediation-form ref="matterMediationFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-mediation-form>
    <matter-matter-info-form ref="matterMatterInfoFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-matter-info-form>
    <matter-legal-notice-form ref="matterLegalNoticeFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-legal-notice-form>
    <matter-simplified-destruction-form ref="matterSimplifiedDestructionFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect"></matter-simplified-destruction-form>
    <matter-legal-evidence-samples-form ref="matterLegalEvidenceSamplesFormModal" :getMatterTypeHistoryList="getMatterTypeHistoryList" :employeeId="matterEmployeeTypeSelect" ></matter-legal-evidence-samples-form>
    <b-modal id="matterAddMatterTypeModal" ref="matterAddMatterTypeModal" centered size="lg" no-close-on-backdrop title="Yeni Dosya Ekle" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.keep_on')" cancel-variant="outline-secondary" @ok="showMatterType" @close="clear()">
      <b-row>
        <b-col class="col-lg-12">
          <b-form>
            <label for="matter-type-input">{{ $t("matter.matter_type")}}</label>
            <b-form-group>
              <b-form-select id="matter-matter-type-input" :placeholder="$t('matter.matter_type')" size="sm" v-model="matterTypeSelect" value-field="id" text-field="name" :options="matterTypeOption" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-12">
          <b-form>
            <label for="matter-related-input">{{ $t("matter.related") }}</label>
            <b-form-group>
              <b-form-select id="matter-employee-input" :placeholder="$t('matter.related')" size="sm" v-model="matterEmployeeTypeSelect" value-field="id" text-field="fullName" :options="matterEmployeeTypeOption" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    getMatterTypeHistoryList: {
      type: Function,
    },
    lawMatterId: {
      type: Number,
    },
    lawMatterMatterTypeId: {
      type: Number,
    },
  },
  data() {
    return {
      matterTypeOption: [],
      matterTypeSelect: 0,
      matterEmployeeTypeOption: [],
      matterEmployeeTypeSelect: 0,
    };
  },
  methods: {
    showMatterType() {
      this.$bvModal.hide("matterAddMatterTypeModal");
      switch (this.matterTypeSelect) {
        case 1:
          this.$refs["matterMatterInfoFormModal"].showMatterInfo(0,this.lawMatterId);
          break;
        case 2:
          this.$refs["matterConsultingFormModal"].showConsulting(0,this.lawMatterId);
          break;
        case 3:
          this.$refs["matterCustomsRegistrationFormModal"].showCustomsRegistration(0,this.lawMatterId);
          break;
        case 4:
          this.$refs["matterStopCustomsFormModal"].showStopCustoms(0,this.lawMatterId);
          break;
        case 5:
          this.$refs["matterEvidenceDetectionFormModal"].showEvidenceDetection(0,this.lawMatterId);
          break;
        case 7:
          this.$refs["matterSmugglingFormModal"].showSmuggling(0,this.lawMatterId);
          break;
        case 8:
          this.$refs["matterLegalNoticeFormModal"].showLegalNotice(0,this.lawMatterId);
          break;
        case 9:
          this.$refs["matterSimplifiedDestructionFormModal"].showSimplifiedDestruction(0,this.lawMatterId);
          break;
        case 10:
          this.$refs["matterMediationFormModal"].showMediation(0,this.lawMatterId);
          break;
        case 11:
          this.$refs["matterLegalEvidenceSamplesFormModal"].showLegalEvidenceSamples(0,this.lawMatterId);
          break;
      }
    },
    showInfo() {
      this.$refs["matterAddMatterTypeModal"].show();
      this.loadLawMatterTypeList();
      this.loadMatterEmployeeList();
    },
    clear() {
      this.matterTypeSelect = 0;
    },
    loadLawMatterTypeList() {
      const controller = {
        name: "LawMatterType",
        actionName: "GetLawMatterTypeList",
      };
      const payload = {
        controller: controller,
      };
      this.$store
        .dispatch("moduleAuth/customServiceGet", payload)
        .then((response) => {
          if (response.data.resultStatus == true) {
            this.matterTypeOption = response.data.lawMatterTypeList;
            this.matterTypeOption.splice(0, 0, this.$nullSelected());
          } else {
            this.$WarningAlert(response.data.resultMessage);
          }
        });
    },
    loadMatterEmployeeList() {
      const data = {
        id: 2,
      };
      const controller = {
        name: "LawEmployee",
      };
      const payload = {
        controller: controller,
        data: data,
      };
      this.$store.dispatch("moduleAuth/getList", payload).then((response) => {
        if (response.data.resultStatus == true) {
          this.matterEmployeeTypeOption = response.data.lawEmployeeList;
          this.matterEmployeeTypeOption.splice(0, 0, this.$nullSelected('fullName'));
          const employeeId = parseInt(localStorage.getItem('EmployeeId'));
          if(employeeId>0){
            this.matterEmployeeTypeSelect = employeeId;
          }
        } else {
          this.$WarningAlert(response.data.resultMessage);
        }
      });
    },
  },
};
</script>
